import React from 'react';
import { Typography, Box, styled } from 'bonfire-kindling';

const StyledIconContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  color: theme.palette.primary.main,
  padding: '0.75rem',
  borderBottom: `1px solid ${theme.palette.grey.lightest}`,
  fontSize: '1.25rem',
  fontWeight: 'bold',
}));
const StyledContainer = styled(Box)(({ theme }) => ({
  border: `1px solid ${theme.palette.grey.lightest}`,
  textAlign: 'center',
}));

const ProjectKPI = ({ icon, value, label }) => {
  return (
    <StyledContainer flex="1" mr={1}>
      <StyledIconContainer>
        {icon}
        {value}
      </StyledIconContainer>
      <Box p={2}>
        <Typography variant="caption" noWrap>
          {label}
        </Typography>
      </Box>
    </StyledContainer>
  );
};
export default ProjectKPI;
